<template>
  <div>
    <div class="d-flex align-items-center min-vh-100 container" >
      <div class="row justify-content-center" style="width: 100%;">
        <div class="col-md-8">
          <div class="card-group">
            <b-card class="p-4">
              <b-card-body>
                <h2>Change Password</h2>
                <change-password-form
                  type="reset"
                  :user-id="userId"
                ></change-password-form>
              </b-card-body>
            </b-card>
            <div class="card text-center py-5 d-md-down-none bg-primary text-white" style="width: 44%;">
              <welcome-card/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import WelcomeCard from "../../components/WelcomeCard";
  import ChangePasswordForm from "../../components/users/ChangePasswordForm";
  export default {
    name: 'user-change-password',
    components: {
      ChangePasswordForm,
      WelcomeCard,
    },
    data() {
      return {
        userId: this.$route.params.userId,
      }
    }
  }
</script>
